import { defineStore } from 'pinia';

export type PopupType = {
	icon?: 'alert' | 'confirm' | string; // 아이콘 (alert, confirm, 아님 직접 넣어줘도 됨)
	content: string; // 보여줄 문구
	subtext?: string; // 보여줄 문구 (서브)
	confirm?: () => void; // 확인 동작
	confirmText?: string; // 확인시 문구
	cancel?: () => void; // 취소 동작
	cancelText?: string; // 취소시 문구
	noCancelBtn?: boolean;
	showTime?: number; // 몇 밀리초동안 보일지
	isRouteConsist?: boolean; // 라우트 이동해도 남아있을지
};
export type ToastType = {
	content: string; // 보여줄 문구
	showTime?: number; // 몇 밀리초동안 보일지
};

type StoreStateType = {
	popup: PopupType;
	toast: ToastType;
	snackbar: PopupType;
};
export const useLoginPopupStore = defineStore('loginPopup', {
	state: (): StoreStateType => {
		return {
			popup: {} as PopupType,
			toast: {} as ToastType,
			snackbar: {} as PopupType,
		};
	},
	getters: {},
	actions: {
		openPopup(payload: PopupType) {
			document.body.classList.add('hidden');
			this.popup = payload;
		},
		closePopup() {
			document.body.classList.remove('hidden');
			this.popup = {} as PopupType;
		},
		openToast(payload: ToastType) {
			this.toast = payload;
		},
		closeToast() {
			this.toast = {} as ToastType;
		},
		openSnackbar(payload: PopupType) {
			this.snackbar = payload;
		},
		closeSnackbar() {
			this.snackbar = {} as PopupType;
		},
		closeAll() {
			this.$reset();
		},
	},
});
